jQuery(document).ready(function($) {
    var breakpoints = [768, 1024, 1320, 1760];
    var breakpointHandler = function() {
        if(!Me.detect.isOldIE()) {
            var breakpoint;
            var viewPortSize = Me.help.dimension.getTotalW();

            if (viewPortSize < breakpoints[0]) {
                breakpoint = String(breakpoints[0] - 1) + "-";
            }

            for (var i in breakpoints) {
                if (breakpoints[Number(i) + 1] != undefined && viewPortSize >= breakpoints[i] && viewPortSize < breakpoints[Number(i) + 1]) {
                    breakpoint = String(breakpoints[i]) + "-" + String(breakpoints[Number(i) + 1] - 1);
                }
                if (viewPortSize >= breakpoints[breakpoints.length - 1]) {
                    breakpoint = String(breakpoints[i]) + "+";
                }
            }

            if (SETTINGS.BREAKPOINT != breakpoint) {
                SETTINGS.BREAKPOINT = breakpoint;
                Me.dispatch.emit('breakpointChanged', this, {breakpoint: breakpoint});
            }
        }
    };
    $(window).resize(breakpointHandler);

    var scrollHandler = function(){
        Me.dispatch.emit('page.scroll');
    };
    //required ["helpMe", "detectMe", "dispatchMe"]
    var deviceHandler = function(){
        if(!Me.detect.isOldIE()) {
            var device;
            var viewPortSize = Me.help.dimension.getTotalW();
            if (viewPortSize < 768) {
                device = "mobile";
            } else if (viewPortSize >= 768 && viewPortSize <= 1024) {
                device = "tablet";
            } else {
                device = "computer";
            }

            if(SETTINGS.DEVICE != device) {
                if(device == "mobile" && !SETTINGS.IS_MOBILE) {
                    SETTINGS.IS_MOBILE = true;
                    Me.dispatch.emit('mobileChanged', this, {mobile: SETTINGS.IS_MOBILE});
                } else if (device != "mobile" && SETTINGS.IS_MOBILE) {
                    SETTINGS.IS_MOBILE = false;
                    Me.dispatch.emit('mobileChanged', this, {mobile: SETTINGS.IS_MOBILE});
                }
                SETTINGS.DEVICE = device;
                Me.dispatch.emit('deviceChanged', this, {device: device});
            }
        }
    };
    $(window).scroll(scrollHandler);
    $(window).resize(deviceHandler);
    Me.dispatch.subscribe('LOAD_MORE.SUCCESS', createRevealableElementWaypoint);

    $('body').on('click', 'a', function (e) {
        if ($(this).attr('href') == " " || $(this).attr('href') == "" || $(this).attr('href') == "#") {
            e.preventDefault();
        }
    });

    $(window).resize();


    // Code to autoplay videos
    var isDesktop = (Me.help.dimension.getTotalW() > 1024) ? true : false;
    var $videos = $("video");

    if ($videos.length != 0) {
        $videos.each(function (index) {
            var $element = $(this);

            var autoplayAttribute = $element.attr('autoplay');

            if (typeof autoplayAttribute == typeof undefined || autoplayAttribute == false) {
                if (isDesktop) {
                   /* var autoplayDataAttribute = $element.data('autoplay');

                    if (autoplayDataAttribute == true) {
                        $element[0].play();
                    }*/
                } else {
                    var $controls = $element.parent().find('.controls');

                    if ($controls.length != 0) {
                        var $play = $controls.find('.play');

                        $controls.css('display', 'block');

                        $play.on('click', function(event) {
                            event.preventDefault();
                            $controls.css('display', 'none');
                            $element[0].play();
                        });
                    }
                }
            }
        });
    }

    createRevealableElementWaypoint();

    function createRevealableElementWaypoint(){
        // Code for elements revealable on scroll
        // How to:
        // - add .has-revealable on the element that contains revealable element: transitions will trigger when this element is reached by half is height
        // - add .is-revealable on elements that need to reveal on scroll
        // - if you need to delay some transition, add those on the element itself
        $('.has-revealable').each(function (index) {
            var $element = $(this);

            if(!$element.hasClass('.is-revealed')){
                var $revealables = $element.find('.is-revealable');

                if ($revealables.length == 0) {
                    return false;
                }

                new Waypoint({
                    element: $element,
                    handler: function (direction) {
                        if (direction == 'down') {
                            $element.addClass('is-revealed');
                            $revealables.addClass('is-revealed');
                        }
                    },
                    offset: $(window).height() * 0.8
                });
            }
        });
    }


    // This is a test to reveal element on scroll one by one
    // $('.is-revealable').each(function (index) {
    //     var $element = $(this);

    //     new Waypoint({
    //         element: $element,
    //         handler: function (direction) {
    //             if (direction == 'down') {
    //                 $element.addClass('is-revealed');
    //             }
    //         },
    //         offset: $(window).height() - getTranslateValues($element).y + parseInt($element.outerHeight(true)) - 200
    //     });
    // });

    // Function to get translate distance values generated by transform: translate...
    // function getTranslateValues($element) {
    //     var matrix = $element.css('transform').replace(/[^0-9\-.,]/g, '').split(',');

    //     var x = matrix[12] || matrix[4];
    //     var y = matrix[13] || matrix[5];

    //     return {
    //         'x': x,
    //         'y': y
    //     };
    // };
    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');

        if(bg){
            $(e.target).css('background-image', 'url(' + bg + ')');
        }
    });

    //========  FORCE BACKGROUND-IMAGE TO LOAD IF NOT HANDLE BY LAZYSIZES  ========//
    setTimeout(function(){
        var $bgImageEl = $('.lazyloaded');

        $bgImageEl.each(function(index, el){
            if($(el).attr('data-bg') && $(el).css('background-image') === 'none'){
                $(el).css('background-image', 'url('+ $(el).attr('data-bg') +')');
            }
        });
    }, 10);
});